export const id = {
  title: 'Hutan Primer',
  subtitle: '30 m, daerah tropis, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Fungsi',
      value: 'Perangkat data ini memetakan luas hutan primer di wilayah-wilayah pantropis global di 2001.',
    },
    {
      label: 'Resolusi',
      value: '30×30 meter',
    },
    {
      label: 'Cakupan geografis',
      value: 'Pan-Tropika',
    },
    {
      label: 'Sumber',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Tanggal konten',
      value: 2001,
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Hutan primer adalah termasuk hutan yang dengan tingkat keanekaragaman hayati tertinggi, menyediakan beraneka layanan ekosistem, sehingga hutan-hutan tersebut amat penting untuk dipantau dalam perencanaan penggunaan lahan nasional dan perhitungan karbon. Set data ini mendefinisikan hutan primer sebagai "tutupan hutan tropis lembab alami dewasa yang belum sepenuhnya dibuka dan tumbuh kembali dalam riwayat baru-baru ini." Para peneliti mengklasifikasikan citra Landsat menjadi data hutan primer, menggunakan algoritma berbeda untuk setiap wilayah.',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
